import { httpGet, httpPost, httpPut, httpPatch } from '../http';
import { customerEndpoints } from '../endpoints';
import type { ApiResponse, RequestConfig, ServiceResponse } from '../types';

export interface MarketingOptOutRecord {
  id?: number;
  customerId: number;
  userId?: number;
  optedOut: 'Y' | 'N';
  source?: string;
  lastUpdateDate?: string | undefined;
  creationDate?: string;
}

export class MarketingService {
  static async get(customerId: number, config?: RequestConfig): ServiceResponse<MarketingOptOutRecord | null> {
    const resp = await httpGet<ApiResponse<MarketingOptOutRecord | MarketingOptOutRecord[] | null>>(
      customerEndpoints.getMarketingOptOut(customerId),
      config
    );
    // API may return array (bare) or envelope with data; normalize
    const raw: any = resp.data as any;
    const data: any = Array.isArray(raw) ? raw : (raw?.data ?? raw);
    let record: MarketingOptOutRecord | null = null;
    if (Array.isArray(data)) {
      // pick the last (most recent) record per requirement
      record = data.length > 0 ? (data[data.length - 1] as MarketingOptOutRecord) : null;
    } else {
      record = (data as MarketingOptOutRecord) || null;
    }
    return { success: true, data: record, message: resp.data?.message, error: resp.data?.error, timestamp: resp.data?.timestamp } as ApiResponse<MarketingOptOutRecord | null>;
  }

  static async create(payload: MarketingOptOutRecord, config?: RequestConfig): ServiceResponse<MarketingOptOutRecord> {
    const resp = await httpPost<ApiResponse<MarketingOptOutRecord>>(
      customerEndpoints.createMarketingOptOut(),
      payload,
      config
    );
    return resp.data;
  }

  static async update(payload: MarketingOptOutRecord, config?: RequestConfig): ServiceResponse<MarketingOptOutRecord> {
    const resp = await httpPut<ApiResponse<MarketingOptOutRecord>>(
      customerEndpoints.updateMarketingOptOut(),
      payload,
      config
    );
    return resp.data;
  }

  static async patch(id: number, payload: Partial<MarketingOptOutRecord>, config?: RequestConfig): ServiceResponse<MarketingOptOutRecord> {
    const resp = await httpPatch<ApiResponse<MarketingOptOutRecord>>(
      customerEndpoints.patchMarketingOptOut(id),
      payload,
      config
    );
    return resp.data;
  }
}

export default MarketingService;


